import { mergeChunks as mergeChunksByMainThread, mergeChunksWorker } from "./merge_chunks.worker.js";


// const mergeChunksWorkerSingletone = new Worker('mergeWorker.js'); //TODO


export function mergeChunks(chunks) {
  //dont launch new thread because already used in worker.
  // Main reason is that renderer process allocates memory for structured clones for communication between trheads
  return mergeChunksByMainThread(chunks);

  if (
    typeof Worker !== 'undefined'
  ) {
    return new Promise((resolve, reject) => {
      const chunkWorkerBlob = new Blob([mergeChunksWorker()], {
        type: "application/javascript",
      });
  
      let worker = new Worker(URL.createObjectURL(chunkWorkerBlob));
  
      worker.postMessage(chunks);  

      worker.onmessage = function(e) {
        resolve(e.data);
        worker.terminate();
      };
    
      worker.onerror = function(e) {
        reject();
        worker.terminate();
      };
    
      worker.postMessage(chunks);
    });
  } else {
    return mergeChunksByMainThread(chunks);
  }
}